/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Woher der Sollwert je Spalte kommt. NONE = keine Einfaerbung.
 * @export
 */
export const DatabaseSubDbTableCompare = {
    None: 'NONE',
    Fixed: 'FIXED',
    OtherSubDb: 'OTHER_SUB_DB'
} as const;
export type DatabaseSubDbTableCompare = typeof DatabaseSubDbTableCompare[keyof typeof DatabaseSubDbTableCompare];


export function DatabaseSubDbTableCompareFromJSON(json: any): DatabaseSubDbTableCompare {
    return DatabaseSubDbTableCompareFromJSONTyped(json, false);
}

export function DatabaseSubDbTableCompareFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbTableCompare {
    return json as DatabaseSubDbTableCompare;
}

export function DatabaseSubDbTableCompareToJSON(value?: DatabaseSubDbTableCompare | null): any {
    return value as any;
}

